<template>
  <section class="dishes">
    <div class="content__title content__title--small dishes__headline">{{content.data.dishes.header}}</div>
    <div class="dishes__intro content__text" v-html="content.data.dishes.intro"></div>
    <Slider />
  </section>
</template>

<script>
import Slider from "../elements/Slider";
export default {
  name: "SliderDishes",
  inject: ['content'],
  components: {
    Slider,
  },
};
</script>
